import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/leader/customer`, { params: params });
	},
	birthdays() {
		return Repository.get(`/company/${company.value.id}/leader/customer/birthdays`);
	},
	assign(payload) {
		return Repository.put(`/company/${company.value.id}/leader/customer/assign`, payload).then((response) => {
			toast.success(`Clientes asignados correctamente.`);
			return response;
		});
	},
	unassign(payload) {
		return Repository.put(`/company/${company.value.id}/leader/customer/unassign`, payload).then((response) => {
			toast.success(`Clientes desasignados correctamente.`);
			return response;
		});
	}
}